export default __webpack_public_path__ + "static/media/02.8f7f1363.jpg";